import rates, { RatesHttpModel } from './rates'
import users, { UsersHttpModel } from './users'
import rateSets, { RateSetsHttpModel } from './rateSets'
import indexes, { IndexesHttpModel } from './indexes'
import advertisers, { AdvertisersHttpModel } from './advertisers'
import tags, { TagsHttpModel } from './tags'

export interface ResourcesModel {
  rates: RatesHttpModel
  users: UsersHttpModel
  indexes: IndexesHttpModel
  rateSets: RateSetsHttpModel
  advertisers: AdvertisersHttpModel
  tags: TagsHttpModel
}

const resources = {
  rates,
  users,
  indexes,
  rateSets,
  advertisers,
  tags
}

export default resources
